export const FEATURES_LIST = [
  {
    title: "Incredible Simplicity",
    description: "You drive and Reach does the work",
    image: {
      desktop: "/images/hero/features/desktop/campaign-creation.svg",
      mobile: "/images/hero/features/mobile/campaign-creation.svg",
    },
  },
  {
    title: "Instant Polling",
    description: "Run polls like a pro without paying for one",
    image: {
      desktop: "/images/hero/features/desktop/instant-polling.svg",
      mobile: "/images/hero/features/mobile/instant-polling.svg",
    },
  },
  {
    title: "Fundraising Campaigns",
    description: "Connect with donors and spend less to raise more",
    image: {
      desktop: "/images/hero/features/desktop/raise-more.svg",
      mobile: "/images/hero/features/mobile/raise-more.svg",
    },
  },
  {
    title: "Make Real Connections",
    description: "Personalize your messages to connect with your constituents",
    image: {
      desktop: "/images/hero/features/desktop/complete-customization.svg",
      mobile: "/images/hero/features/mobile/complete-customization.svg",
    },
  },
  {
    title: "Master Your Data",
    description: "Outsmart your opponents with data-driven insights",
    image: {
      desktop: "/images/hero/features/desktop/track-everything.svg",
      mobile: "/images/hero/features/mobile/track-everything.svg",
    },
  },
  {
    title: "Don't Blast, Connect",
    description: "Have real conversations with your constituents",
    image: {
      desktop: "/images/hero/features/desktop/inbox-feature.svg",
      mobile: "/images/hero/features/mobile/inbox-feature.svg",
    },
  },
];
